import {
  PlayerName,
  PlayerProfile,
  PlayerSubheader
} from '@library/components/player';
import { MEMBER_GROUP_PERMISSIONS } from '@bo-constants/permissions';
import type { MemberGroupMember } from '@library/types/memberGroups';
import { UserKebabMenu } from '@library/components/menus/kebabMenu/UserKebabMenu';
import type { UserRoleMenuActions } from '@library/components/menus/kebabMenu/UserKebabMenu';
import { formatDateFromYMD } from '@library/component-utils/dateTime';
import { useHasRolePermission } from '@bo-hooks/permissions/useHasRolePermission';

const { MEMBER_GROUPS_EDIT } = MEMBER_GROUP_PERMISSIONS;

export const MemberGroupMemberRow = ({
  member,
  onRowClick,
  menuActions
}: {
  member: MemberGroupMember;
  onRowClick: (id: string) => void;
  menuActions: UserRoleMenuActions;
}) => {
  const { id } = member;
  const canEditMemberGroup = useHasRolePermission(MEMBER_GROUPS_EDIT);

  return (
    <div
      aria-hidden="true"
      className="border-soFresh-140 text-soClean-110 hover:bg-soFresh-120 group/user text-2xs relative flex h-16 cursor-pointer items-center border-b xl:text-xs"
      data-testid={`member-group-member-${id}`}
      onClick={() => onRowClick(id)}
    >
      <PlayerProfile
        className="flex h-full basis-96 items-center overflow-x-auto px-3 pt-1.5"
        name={member.full_name}
        subheader={member.email}
      >
        <div className="flex flex-col">
          <PlayerName className="font-heebo text-soClean-100 block text-sm font-medium capitalize tracking-tight" />
          <PlayerSubheader className="text-soClean-170 font-heebo block text-xs font-medium tracking-tight" />
        </div>
      </PlayerProfile>
      <p
        className="flex flex-1 p-3"
        data-testid={`member-group-member-${id}-userid`}
      >
        {member.id}
      </p>
      <p
        className="flex flex-1 p-3"
        data-testid={`member-group-member-${id}-created-at`}
      >
        {formatDateFromYMD(member.created_at)}
      </p>
      <div className="absolute right-2">
        {canEditMemberGroup && (
          <UserKebabMenu
            editMessage="Edit member"
            id={id}
            menuActions={menuActions}
          />
        )}
      </div>
    </div>
  );
};
